export default __webpack_public_path__ + "static/media/invoice.c09deb6d.csv";